import { Container, Group, Stack, Text, Transition } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  customComponent?: React.ReactNode;
  showBack?: boolean;
  route?: string;
  showHome?: boolean;
  bg?: string;
  customComponentHide?: boolean;
};

function Header({
  title,
  customComponent,
  showBack,
  route,
  bg,
  customComponentHide,
}: Props) {
  const [showTitle, setShowTitle] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Show title when scrolled down more than 50px
      setShowTitle(scrollPosition > 30);
    };

    // Try to find the scrollable container - look for the specific Stack with overflowY auto
    const scrollableContainer = document.querySelector(
      "#dashboard-layout"
    ) as HTMLElement;

    if (scrollableContainer) {
      const handleContainerScroll = () => {
        const scrollPosition = scrollableContainer.scrollTop;
        setShowTitle(scrollPosition > 30);
      };

      scrollableContainer.addEventListener("scroll", handleContainerScroll);
      return () =>
        scrollableContainer.removeEventListener(
          "scroll",
          handleContainerScroll
        );
    } else {
      // Fallback to window scroll
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return (
    <Container
      w="100%"
      size="full"
      bg={bg || "white"}
      styles={{
        root: {
          position: "sticky",
          top: 0,
          zIndex: 20,
          borderBottom: showTitle
            ? "1px solid var(--mantine-color-gray-2)"
            : "none",
        },
      }}
    >
      <Stack w="100%" h={56} justify="center">
        <Group justify="space-between">
          <Group gap="xs">
            {showBack && (
              <Group>
                <IconArrowRight
                  strokeWidth={1}
                  onClick={() => (route ? navigate(route) : navigate(-1))}
                />
              </Group>
            )}
            <Text>
              <Transition
                mounted={showTitle}
                transition="fade"
                duration={100}
                timingFunction="ease"
              >
                {(styles) => <div style={styles}> {showTitle && title}</div>}
              </Transition>
            </Text>
          </Group>
          {customComponentHide ? (
            <Transition
              mounted={showTitle}
              transition="fade"
              duration={100}
              timingFunction="ease"
            >
              {(styles) => (
                <div style={styles}> {showTitle && customComponent}</div>
              )}
            </Transition>
          ) : (
            customComponent
          )}
        </Group>
      </Stack>
    </Container>

    // <Stack w="100%">
    //   <Card py="0" radius="md" withBorder m="5" mb="0">
    //     <Grid justify="center" align="center" h="50px">
    //       <Grid.Col span={4}>
    //         {showBack && (
    //           <Group pl="sm">
    //             <IconChevronRight
    //               strokeWidth={1}
    //               onClick={() => (route ? navigate(route) : navigate(-1))}
    //             />
    //           </Group>
    //         )}
    //       </Grid.Col>
    //       <Grid.Col span={4}>
    //         <Stack h={50} justify="center" align="center">
    //           <Text style={{ textWrap: "nowrap" }} size="sm">
    //             {title}
    //           </Text>
    //         </Stack>
    //       </Grid.Col>
    //       <Grid.Col span={4}>
    //         {showHome && (
    //           <Group justify="end">
    //             <IconHome strokeWidth={1} onClick={() => navigate("/")} />
    //           </Group>
    //         )}
    //       </Grid.Col>
    //     </Grid>
    //   </Card>
    // </Stack>
  );
}

export default Header;
